import React, { useState, useEffect, useCallback, useRef } from 'react';

// Debounce function setup
function debounce(fn, delay) {
  let timeoutId;
  return function (...args) {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      fn(...args);
    }, delay);
  };
}

const RangeSlider = ({ min, max, start, end, append = "", prepend = "", sliderColor = "var(--primary-color)", onValueChange }) => {
  const [minValue, setMinValue] = useState(parseInt(start) || min);
  const [maxValue, setMaxValue] = useState(parseInt(end) || max);

  // Ensure onValueChange is callable
  const safeOnValueChange = useCallback((...args) => {
    if (typeof onValueChange === 'function') {
      onValueChange(...args);
    }
  }, [onValueChange]);

  // Debounce setup
  const debouncedOnValueChange = useRef(debounce(safeOnValueChange, 100));

  // Effect to handle min/max value changes with debouncing
  useEffect(() => {
    debouncedOnValueChange.current({ min: minValue, max: maxValue });
  }, [minValue, maxValue]);

  const handleMinChange = (newMin) => {
    if (newMin < maxValue) {
      setMinValue(newMin);
    }
  };

  const handleMaxChange = (newMax) => {
    if (newMax > minValue) {
      setMaxValue(newMax <= max ? newMax : max);
    }
  };

  const sliderTrackStyle = {
    background: `linear-gradient(to right, #dadae5 ${(minValue - min) / (max - min) * 100}%, ${sliderColor} ${(minValue - min) / (max - min) * 100}%, ${sliderColor} ${(maxValue - min) / (max - min) * 100}%, #dadae5 ${(maxValue - min) / (max - min) * 100}%)`,
  };

  const formatDisplayValue = (value, isMax) =>
    isMax && value == max ? `${prepend}${value}${append}+` : `${prepend}${value}${append}`;

  return (
    <div className="range-slider">
      <div className="text-center text-lg">{formatDisplayValue(minValue, false)} - {formatDisplayValue(maxValue, true)}</div>
      <div className="relative">
        <div className="slider-track" style={sliderTrackStyle}></div>
        <input
          type="range"
          min={min}
          max={max}
          value={minValue}
          onChange={(e) => handleMinChange(Number(e.target.value))}
        />
        <input
          type="range"
          min={min}
          max={max}
          value={maxValue}
          onChange={(e) => handleMaxChange(Number(e.target.value))}
        />
      </div>
    </div>
  );
};

export default React.memo(RangeSlider);
